/**
 * @module lib/commercial/dfp-ads/user-events
 * @description Creates a user event timer, which will trigger an event after 5 seconds of user inactivity
 */
import ee from "lib/eventemitter";
import isNil from "lodash/isNil";
import logger from "utils/logger";
import tgamConfig from "config/tgam";
import { getProp } from "utils/utils";
import { getUrlVars } from "utils/urls";

const debugTag = "[USER-EVENT]";
const debugClock = !isNil(getUrlVars().clock);

let userEventClock;
let userTimer = 0;
const isSection = getProp(tgamConfig, "meta.isSectionPage", false);
const idleTimeout = isSection
  ? getProp(tgamConfig, "env.adUserTrackingTimeoutSection", 30)
  : getProp(tgamConfig, "env.adUserTrackingTimeoutArticle", 5);

/**
 * @method startUserEventClock
 * @description starts the clock to keep track of user activity
 */
function startUserEventClock() {
  userEventClock = setInterval(() => {
    userTimer += 1;
    debugClock && logger.info(`${debugTag}: userTimer = ${userTimer}`);
    if (userTimer >= idleTimeout) {
      debugClock && logger.info(`${debugTag}: user is idle`);
      alterTimer();
      ee.trigger("userTimer:idle");
    }
  }, 1000);
}

/**
 * @method alterTimer
 * @description Either restart the clock from zero or stop it until a user event fires
 * @param {Boolean} reset - should the clock be restarted from zero?
 */
function alterTimer(reset = false) {
  debugClock && logger.info(`${debugTag}: reset user event clock`);
  clearInterval(userEventClock);
  if (reset === true) {
    userTimer = 0;
    startUserEventClock();
  }
}

/**
 * @method dynamicAdUserTracking
 * @description Initialize the user tracking for ad refresh purposes
 */
export default function dynamicAdUserTracking() {
  startUserEventClock();
  ee.on("windowScroll.throttled", () => {
    alterTimer(true);
  });
  ee.on("mouseMove.throttled", () => {
    alterTimer(true);
  });
}
